// removes # and everything after ?
export const removeHashAndQueryParams = (urlHash: string) => urlHash.replace('#', '').replace(/\?.*/, '')
